<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="血压数据" prop="bloodPressure" >
        <a-input-number v-model="form.bloodPressure" placeholder="请输入血压数据" />
      </a-form-model-item>
      <a-form-model-item label="血氧数据" prop="bloodOxygen" >
        <a-input-number v-model="form.bloodOxygen" placeholder="请输入血氧数据" />
      </a-form-model-item>
      <a-form-model-item label="平均心率(次/分钟)" prop="ecgData" >
        <a-input-number v-model="form.ecgData" placeholder="请输入平均心率(次/分钟)" />
      </a-form-model-item>
<!--      <a-form-model-item label="HRV数值(ms)" prop="hrvData" >-->
<!--        <a-input-number v-model="form.hrvData" placeholder="请输入HRV数值(ms)" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="体温" prop="bodytemperatureData" >-->
<!--        <a-input-number v-model="form.bodytemperatureData" placeholder="请输入体温" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="压力值" prop="pressureData" >-->
<!--        <a-input-number v-model="form.pressureData" placeholder="请输入压力值" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="心率平均值(次/分)" prop="heartData" >-->
<!--        <a-input-number v-model="form.heartData" placeholder="请输入心率平均值(次/分)" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="血糖值(毫摩尔/升)" prop="bloodSugarData" >-->
<!--        <a-input-number v-model="form.bloodSugarData" placeholder="请输入血糖值(毫摩尔/升)" />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getJoe, addJoe, updateJoe } from '@/api/joe/standard'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        sysUserId: null,

        bloodPressure: null,

        bloodOxygen: null,

        ecgData: null,

        hrvData: null,

        bodytemperatureData: null,

        pressureData: null,

        heartData: null,

        bloodSugarData: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        sysUserId: null,
        bloodPressure: null,
        bloodOxygen: null,
        ecgData: null,
        hrvData: null,
        bodytemperatureData: null,
        pressureData: null,
        heartData: null,
        bloodSugarData: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getJoe({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateJoe(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addJoe(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
